import { writable } from 'svelte/store';
import collect from 'collect.js';
import { debouncer } from '@/Services/Helpers.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	// eslint-disable-next-line no-unused-vars
	let _store;
	let _pending = [];
	let processing = false;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	const debounce = debouncer(500, 5000);

	async function processPending() {
		if (!processing) {
			processing = true;
			const updatesTopoBeProcessed = _pending;
			_pending = [];
			await methods.applyPriceUpdates(updatesTopoBeProcessed);
			processing = false;
		}
	}

	const methods = {
		// Sport Selection Updates need to be throttled. Browser can get unresponsive
		// with 300+ updates per second trying to update store
		addToPending(items = []) {
			_pending = _pending.concat(items);
			debounce(() => processPending());
		},

		async applyPriceUpdates(data) {
			if (!data) return;

			let selectionUpdates = collect(data);
			await update((items) => {
				selectionUpdates.each((selectionUpdate) => {
					let selectionToUpdate = items.firstWhere('id', String(selectionUpdate.id));
					if (selectionToUpdate) {
						delete selectionUpdate.id;
						// Sport selection can come through in meta which should be treated as model properties
						// noinspection JSUnusedAssignment
						selectionToUpdate = selectionUpdate.meta
							? Object.assign(selectionToUpdate, selectionUpdate.meta)
							: Object.assign(selectionToUpdate, selectionUpdate);
					}
				});

				return items;
			});
		}
	};

	//processPending();

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
